import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import pt from './locales/pt.json';

// Puerta de `src/i18n/i18n.js` (legado, borrado en T4 de specs/contexts/shared-kernel/tasks.md).
// Misma inicialización, mismos 3 recursos completos cargados eager y mismo
// `interpolation.escapeValue: false` — no se corrige aquí (spec.md §2.11, improvements.md #5).

const savedLang = localStorage.getItem('language') || 'es';

void i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
    pt: { translation: pt },
  },
  lng: savedLang,
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;
